import { ApiProperty } from '@nestjs/swagger';
export class UploadDto {
    @ApiProperty({ type: 'file', format: 'binary' })
    file: string;
    @ApiProperty()
    id: number;
}